/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-10 15:47:28
 * @FilePath: \ioc_base\src\modules\buildingConfig\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const api = {
  deviceMan: {
    getDeviceTypeListByPage: "/bms/device/getDeviceTypeListByPage.json", // 查询设备类型
    getDeviceInfoDetailsById: "/bms/device/getDeviceInfoDetailsById.json", // 查询设备详情
    getDeviceListByPage: "/bms/device/getDeviceListByPage.json", // 查询设备列表
    updateDeviceInfoById: "/bms/device/updateDeviceInfoById.json", // 修改设备信息
    getFactoryListByPage: "/bms/device/getFactoryListByPage.json", // 查询厂商
    //queryAssociationalDeviceTree: '/cms/account/queryAssociationalDeviceTree.json', // 查询区域树
    queryAssociationalDeviceTree: "/cms/area/queryAreaByAccountName.json", // 查询区域树
    deleteDeviceInfoById: "/bms/device/deleteDeviceInfoById.json", // 删除设备
    updateDeviceArea: "/bms/device/updateDeviceArea.json", // 设备挪入挪出
    updateCameraFeature: "bms/device/updateCameraFeature.json", // 设备批量修改虚拟属性
    queryDeviceTypeCount: "bms/device/queryDeviceTypeCount.json", // 设备批量修改虚拟属性
    getDeviceExportList: "/bms/device/getDeviceExportList.json", //导出文件
    deviceImportList: "/bms/device/deviceImportList.json" //导入文件
  },
  queryDeviceWorkGroup: "/bms/device/queryDeviceWorkGroup.json", //查询设备组树 2021.1.26
  addDeviceWorkGroup: "/bms/device/addDeviceWorkGroup.json",
  updateDeviceWorkGroup: "/bms/device/updateDeviceWorkGroup.json",
  deleteDeviceWorkGroup: "/bms/device/deleteDeviceWorkGroup.json",
  updateDeviceDeviceWorkGroup: "/bms/device/updateDeviceDeviceWorkGroup.json", //挪入挪出设备组信息
  downloadFile: "/bms/device/exportFireDeviceList.json", //导出消防设备信息
  upFile: "/common/file/batchFileload.json", //图片上传
  // 迭代五 消防列表
  queryFirefightOperationList:
    "/bas/firefightoperation/queryFirefightingOperationList.json", //查询运行数据列表
  addBuilding: "/cms/building/addBuilding.json", //新增楼栋/楼层信息
  updateBuilding: "/cms/building/updateBuilding.json", //修改楼栋/楼层信息
  deleteBuilding: "/cms/building/deleteBuilding.json", //删除楼栋/楼层信息
  queryBuildingTree: "/cms/building/queryBuildingTree.json", //查询楼栋/楼层树
  batchFileload: "/common/file/batchFileload.json", // 上传图片
  // queryFireDeviceStatus: 'cms/accessportal/queryFireDeviceStatus.json', // 查询消防主机状态更新
  queryDeviceStatus: "cms/accessportal/queryDeviceStatus.json", // 查询消防主机状态更新
  queryFireDeviceList: "bms/device/queryFireDeviceList.json ", // 查询设备列表
  queryFirefightingCameraList: "/bms/device/queryFirefightingCameraList.json ", // 查询视频配置信息
  updateFirefightingCamera: "/bms/device/updateFirefightingCamera.json", // 修改视频配置信息
  queryDeviceWorkGroupDeviceTree:
    "/bms/device/queryDeviceWorkGroupDeviceTree.json", //查询消防设备组设备树
  queryDeviceWorkGroupDeviceTreeNew:
    "/bms/device/queryDeviceWorkGroupDeviceTreeLimit.json", //查询消防设备组设备树New
  queryDeviceWorkGroupDeviceTreeMore:
    "/bms/device/queryDeviceWorkGroupDeviceTreeOffset.json", //查询消防设备组设备树More
  updateDeviceBuilding: "/cms/building/updateDeviceBuilding.json", //保存设备图纸位置
  getDeviceDetail: "/bms/device/queryDeviceDetails.json", //查询设备信息,
  getCanvasList: "/cms/building/queryDeviceListByBuilding.json", //查询打点设备信息,
  config: {
    queryConfigList: "/bms/device/queryFireFightingOperationConfigList.json",
    addConfigStep: "/bms/device/addFireFightingOperationConfig.json", //新增步骤
    updateConfigStep: "/bms/device/updateFireFightingOperationConfig.json", //修改步骤
    deleteConfigStep: "/bms/device/deleteFireFightingOperationConfig.json" //删除步骤
  },
  // 迭代N
  queryBuildingList: " /cms/building/queryBuildingList.json", //查询楼栋楼层list
  getPersonList: " /vas/personnel/queryPersonListApi.json", //查询人员list
  querySecurityWorkGroup: "/cms/workgroup/querySecurityWorkGroup.json", //查询保卫工作组树
  queryPersonList: "/vas/personnel/queryPersonList.json", //获取列表
  queryAccouts: "/cms/account/queryResultsByPagApi.json", // 按照条件查询账户信息

  addSecurityWorkGroup: "/cms/workgroup/addSecurityWorkGroup.json", //新增保卫工作组
  updateSecurityWorkGroup: "/cms/workgroup/updateSecurityWorkGroup.json", //修改保卫工作组
  deleteSecurityWorkGroup: "/cms/workgroup/deleteSecurityWorkGroup.json", //删除保卫工作组

  addSecurityInfo: "/cms/workgroup/addSecurityInfo.json", //新增当前保卫工作组保卫信息
  queryOutSecurityInfo: "/cms/workgroup/queryOutSecurityInfo.json", //查询不在当前保卫工作组保卫信息
  queryInSecurityInfo: "cms/workgroup/queryInSecurityInfo.json", //查询在当前保卫工作组保卫信息
  getSecurityInfoList: "/cms/workgroup/querySecurityInfo.json", //查询保卫工作组及子节点保卫信息
  deleteSecurityInfo: "/cms/workgroup/deleteSecurityInfo.json" //删除保卫工作组保卫信息
};
